/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {SettingPageTitle} from '../components/header/SettingPageTitle'
import {useAuth} from '../../../modules/auth'
import {collection, onSnapshot, doc} from '@firebase/firestore'
import db from 'services/firebase'
import {ToastContainer} from 'react-toastify'
import {KTIcon} from '_metronic/helpers'
import {AddPersonnelModal} from 'app/pages/personnel-management/components/AddPersonnelModal'
import Searchbar from 'app/components/Searchbar'
import NavTabs from 'app/components/NavTabs'
import {ListLoading} from 'app/components/ListLoading'

const tabs = [
  {
    title: 'Your Organization',
    slug: 'users',
    href: '/company-settings/users',
  },
  {
    title: 'Auditors',
    slug: 'auditors',
    href: '/company-settings/users/auditors',
  },
  // {
  //   title: 'Managed Service Providers',
  //   slug: 'msp',
  //   href: '/company-settings/msp',
  // },
]

const SettingsUserpermissions = () => {
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(
    location.pathname.split('/').at(-1) === '' ? tabs[0].slug : location.pathname.split('/').at(-1)
  )
  const {currentUser} = useAuth()
  const [users, setUsers] = useState<any[]>([])
  const [isOpen, setIsOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [isDataFetching, setIsDataFetching] = useState(true)

  const toggleDrawer = () => {
    setIsOpen(!isOpen)
  }

  const closeDrawer = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    if (location.pathname.includes('auditors')) {
      setActiveTab('auditors')
    } else if (location.pathname.includes('msp')) {
      setActiveTab('msp')
    } else {
      setActiveTab('users')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getPersonnel()
  }, [])

  const getPersonnel = () => {
    try {
      setIsDataFetching(true)
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'employees')

      const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
        const risksData = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
            role: doc.data().role,
          }))
          .filter((item) => item.role !== 'Auditor')

        setUsers(risksData)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting personnels:', error)
    } finally {
      setTimeout(() => setIsDataFetching(false), 500)
    }
  }

  const filteredUsers = useMemo(
    () => users.filter((user) => user.full_name.toLowerCase().includes(searchTerm)),
    [users, searchTerm]
  )

  return (
    <>
      <SettingPageTitle icon='Settings.svg' title='Settings' desc=' Manage your settings'>
        Personnel Management
      </SettingPageTitle>
      <div className={`card mb-5 mb-xl-8`}>
        <div className='mt-4'>
          <NavTabs tabs={tabs} activeTab={activeTab!} />
        </div>

        <div className='card-body'>
          <>
            <div className='d-flex align-items-center justify-content-between position-relative mb-4'>
              <div className='flex-lg-fill'>
                <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
              </div>

              <div>
                <button
                  type='button'
                  className='btn btn-sm fs-6'
                  onClick={toggleDrawer}
                  style={{height: '40px', background: '#0E9F6E', color: '#fff'}}
                  onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                    (e.currentTarget.style.backgroundColor = '#148363')
                  }
                  onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                    (e.currentTarget.style.backgroundColor = '#0E9F6E')
                  }
                >
                  <KTIcon iconName='plus' className='fs-2 text-white' />
                  Add Employee
                </button>
              </div>
            </div>
            <AddPersonnelModal isOpen={isOpen} onClose={closeDrawer} />
          </>

          {isDataFetching ? (
            <div className='position-relative' style={{height: '245px'}}>
              <ListLoading />
            </div>
          ) : (
            <div className='table-responsive' style={{height: '500px', overflowY: 'auto'}}>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold fs-7' style={{color: '#5A5A5A'}}>
                    <th className='min-w-200px '>NAME</th>
                    <th className='min-w-200px'>EMAIL</th>
                    <th className='min-w-100px '>ROLE</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}

                <tbody>
                  {filteredUsers && filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                      <tr>
                        <td>
                          <div className='d-flex align-items-center fs-6 fw-semibold'>
                            {user.full_name}
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center fw-semibold'>{user.email}</div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center fw-semibold'>{user.role}</div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <>
                      <td colSpan={6} className='text-center'>
                        <div className=''>
                          <img src='/media/buttons/emptystate.svg' alt='' />
                          <div className='m-5 fs-5'>
                            <p style={{fontWeight: 'bold'}}>No Employees Found</p>
                          </div>
                          <p className=''>
                            We couldn't find any personnel that match your search. Maybe try a
                            different search!
                          </p>
                        </div>
                      </td>
                    </>
                  )}
                </tbody>

                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

export default SettingsUserpermissions
